import React from "react";
import { Icon } from "@iconify/react";
import Revolutionize from "./../../shared/revolutionize";
import Chatbot from "../chatbot/chatbot";
import { useTranslation } from "react-i18next";

const AboutBanner = () => {
  const { t } = useTranslation();

  const cardData = [
    {
      number: "700+",
      title: "Users",
      description:
        "We are proud to have a growing community of 700+ users who trust our platform for seamless legal assistance and services. Our user-centric approach ensures a hassle-free experience.",
    },
    {
      number: "30+",
      title: "Law Firms Associated",
      description:
        "Partnering with 30+ reputable law firms, we connect users with experienced legal professionals. Our network ensures access to expert guidance across various legal matters.",
    },
    {
      number: "06",
      title: "Serving in 6 Cities Across the UK",
      description:
        "Expanding our reach, we are now providing services in six major US cities, making legal assistance more accessible and convenient for individuals and businesses.",
    },
  ];

  return (
    <>
      <div className=" about-banner-main max-md:pt-[80px] pt-[237px] relative pb-[83px] w-100 bg-[#F0F2F4] h-full  rounded-tl-none rounded-tr-none rounded-bl-[38px] rounded-br-[38px]">
        <div className="banner-inner back-banner max-md:!h-[70vh] max-xxxl:h-[100vh] h-[calc(100vh_-_250px)] w-[100%] absolute top-0 z-[1] right-0"></div>
        <div className="content z-[2] relative max-xxxl:max-w-[90%]  max-w-[80%] m-auto flex flex-col justify-center items-center">
          <div>
            <h1 className="text-center text-white font-sora tracking-[-2px] leading-[90px]">
              {t("aboutUs.title")}
            </h1>
            <h1 className="text-center gradient-text font-sora tracking-[-2px] leading-[90px]">
              {t("aboutUs.subtitle")}
            </h1>
            <h6 className="mt-[10px] text-white m-auto text-center tracking-[-0.8px] max-w-[551px]">
              {t("aboutUs.desc")}
            </h6>
          </div>
          <div className="relative grid grid-cols-3 max-sm:!grid-cols-1  gap-[30px] mt-[110px]">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="py-[50px] px-[30px] flex flex-col gap-[10px]  h-fit items-center text-center max-w-sm mx-auto relative w-full  "
              >
                <img
                  src="../../assets/images/about/abt-banner-cards.png"
                  alt="card"
                  className=" max-w-[419px] w-full max-xxl:max-h-[298px] max-h-[320px] h-full absolute z-[-1] top-0"
                />
                <div className="absolute top-[-10%]">
                  <h4 className="font-semibold  gradient-text leading-[40px] text-white">
                    {card.number}
                  </h4>
                </div>
                <h6 className="font-bold font-manrope leading-[35px] text-blue">
                  {card.title}
                </h6>
                <h6 className="font-normal font-manrope txt-color tracking-[-0.8px]">
                  {card.description}
                </h6>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-center gap-[47px] pt-[82px] max-sm:gap-[10px]">
            <img
              src="../../assets/images/about/users-abt.png"
              alt="users"
              className="w-[160px] h-[80px] max-sm:w-[100px] max-sm:h-[50px]"
            />

            <div className="flex items-center">
              {Array(5)
                .fill()
                .map((_, index) => (
                  <Icon
                    key={index}
                    icon="material-symbols:star"
                    width={28}
                    height={28}
                    color="#E7B025"
                    className="max-sm:w-[22px] h-[22px]"
                  />
                ))}
            </div>
            <h4 className="esmall font-semibold tex-grey max-sm:!text-[18px]">
              20k+ users
            </h4>
          </div>
        </div>
      </div>
      <Revolutionize txt={t("aboutUs.banner")} />
      <Chatbot />
    </>
  );
};

export default AboutBanner;
